import React from 'react';
import { Formik } from 'formik';
import { MdArrowBackIosNew } from 'react-icons/md';
import { Navigate, useNavigate } from 'react-router-dom';

interface Iprops {
	heading?: string;
	handleSubmitForm: (e: React.FormEvent<HTMLFormElement>) => void;
	initialValues?: any;
	FORM_VALIDATION?: {};
	children?: any;
}

const FormLayout = ({
	children,
	heading,
	initialValues,
	FORM_VALIDATION,
	handleSubmitForm,
}: Iprops) => {
	const navigate = useNavigate();
	return (
		<div className="py-5 formLayout">
			<div className="container bg-lightgray p-3">
				<div
					className="d-inline-flex align-items-center back__button btn btn-sm"
					onClick={() => {
						navigate(-1);
					}}>
					<MdArrowBackIosNew size={12} />
					<span className="mx-2">Back</span>
				</div>

				<div className="mt-2">
					<div className="row">
						<div className="col-md-6 ">
							<h4 className="formHeading">{heading}</h4>
							<Formik
								initialValues={initialValues}
								validateOnMount={true}
								validationSchema={FORM_VALIDATION}
								onSubmit={handleSubmitForm}>
								{children}
							</Formik>
						</div>
						<div className="col-sm-6"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(FormLayout);
